import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcEdit24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m17.468 2a2.04 2.04 0 0 1 1.503.634l2.301 2.278c.446.47.728 1.057.728 1.69 0 .564-.211 1.151-.728 1.668l-11.741 11.764c-.282.282-.634.54-.963.588l-5.307 1.338c-.07.024-.14.024-.235.024a.937.937 0 0 1 -.704-.306c-.212-.211-.376-.516-.305-.798l.023-.118 1.268-5.119c.094-.399.282-.751.54-1.033l11.882-11.882a2.475 2.475 0 0 1 1.738-.728zm-12.07 13.831-.07.07c-.024.024-.047.118-.07.212l-.87 3.475 3.429-.822a.496.496 0 0 0 .234-.093l.094-.094zm9.017-8.947-7.561 7.562 2.7 2.724 7.585-7.585-2.724-2.7zm2.982-2.841c-.093 0-.187.023-.258.117l-1.315 1.315 2.748 2.748 1.315-1.339a.3.3 0 0 0 .093-.234.455.455 0 0 0 -.14-.306l-2.184-2.184c-.07-.094-.165-.117-.259-.117z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcEdit24;
